import { Injectable } from '@angular/core';
import { Store } from '../../core/services/store.service';
import { CsrfToken } from '../../core/services/api.service';

@Injectable({
  providedIn: 'root',
})
export class CsrfStoreService extends Store<CsrfToken> {

  constructor() {
    super(null, 'csrf_token');
  }

  clear(){
    this.setState(null);
  }
}
